<template>
  <div class="brand-menu">
    <b-nav tabs>
      <b-nav-item
          :to="{name: 'brand'}"
          :active="this.$router.currentRoute.name == 'brand'"
      >Поиск
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandInfo', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandInfo'"
      >Инфо
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandContent', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandContent'"
      >
        Контент
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandError', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandError'"
      >
        Ошибки
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandSemantics', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandSemantics'"
      >Семантика
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandSemanticst', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandSemanticst'"
      >Семантика 2
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandCountry', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandCountry'"
      >Спрос по странам WW
      </b-nav-item>
      <b-nav-item
          :to="{name: 'salesAnalyticsCountryBrand'}"
          :active="this.$router.currentRoute.name == 'salesAnalyticsCountryBrand'"
          target="_blank"
      >Продажи по странам
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandDynamics', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandDynamics'"
      >Динамика спроса
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandProducts', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandProducts'"
      >Товары
      </b-nav-item>
      <b-nav-item
          :to="{name: 'brandPosition', params: {id: saleId}}"
          :active="this.$router.currentRoute.name == 'brandPosition'"
      >Позиции
      </b-nav-item>
      <b-nav-item
        :to="{name: 'brandDescriptions', params: {id: saleId}}"
        :active="this.$router.currentRoute.name == 'brandDescriptions'"
      >Описания
      </b-nav-item>
      <b-nav-item
          class="moz-crm"
          :href="'https://famaga.org/index.php?option=com_oscrm&view=brandform&id='+ saleId"
          target="_blank"
      >MOZ CRM
      </b-nav-item>

    </b-nav>
  </div>
</template>

<script>
export default {
  name: "topMenu",
  props: {
    saleId: String
  },
}
</script>

<style scoped>
.brand-menu {
  padding: 0 0 20px 25px;
}

.moz-crm a {
  color: grey;
}
</style>